// extracted by mini-css-extract-plugin
export var caption = "staggeredImageCards-module--caption--bc50b";
export var card = "staggeredImageCards-module--card--b2b16";
export var cards = "staggeredImageCards-module--cards--8e7fd";
export var decorations = "staggeredImageCards-module--decorations--f1444";
export var discoBall = "staggeredImageCards-module--disco-ball--e07ba";
export var image = "staggeredImageCards-module--image--813c3";
export var imageWrapper = "staggeredImageCards-module--image-wrapper--b20f9";
export var inner = "staggeredImageCards-module--inner--19247";
export var staggeredImageCards = "staggeredImageCards-module--staggered-image-cards--909a8";
export var subtitle = "staggeredImageCards-module--subtitle--f0241";
export var title = "staggeredImageCards-module--title--8492b";